<template>
  <BlockContainer :hasHover="!isDisabled" class="p-4 h-100 border-payment-status" :class="getSummaryStatus.borderClass">
    <div class="d-flex align-items-center mb-4">
      <i class="h4" :class="getSummaryStatus.iconClass" />
      <h5 class="ml-4">Betalingsstatus</h5>
    </div>

    <div class="mt-4 pt-2">
      <div class="d-flex">
        <div class="d-flex-row align-items-center">
          <template v-if="!isFree">
            <p class="mb-1">{{ getSummaryStatus.status }}</p>
            <h4 v-if="getSummaryStatus.amountDue > 0">
              <Currency :amount="getSummaryStatus.amountDue" />
            </h4>
          </template>
          <div v-else>
            <p>
              Få husleien på konto til rett tid - vi gjør jobben for deg! Automatisk innkreving, purring og inkasso av
              husleien er inkludert i alle våre abonnement.
              <a href="https://www.husleie.no/utleier/innkreving-av-husleien" target="_blank" rel="noopener">Les mer</a>
            </p>
            <UpdateSubscriptionButton
              :landlord-id="landlordId"
              :tenancy-id="tenancyId"
              buttonCTA="Aktiver fakturering"
              origin="dashboard_tenancyview_overview_invoicing"
            />
          </div>
        </div>
      </div>
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';
import i18nCommon from '@modules/i18n/mixins/Common';
import UpdateSubscriptionButton from '@/components/upsale/UpdateSubscriptionButton.vue';
import subscription from '@/mixins/tenancy/subscription.js';

export default {
  components: {
    BlockContainer,
    UpdateSubscriptionButton,
    Currency,
  },
  mixins: [i18nCommon, subscription],
  props: {
    landlordId: [String, Number],
    tenancyId: [String, Number],
    isDisabled: {
      type: Boolean,
      default: false,
    },
    accountingSummary: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    getSummaryStatus() {
      const base = ['d-flex', 'align-items-center', 'justify-content-center', 'icon-container'];

      if (this.isDisabled) {
        return {
          borderClass: 'border-status-secondary',
          status: null,
          iconClass: ['budicon-cross-sign'],
          class: base.concat(['bg-op-secondary']),
          amountDue: null,
        };
      }

      if (this.accountingSummary) {
        if (this.accountingSummary.maxDeltaDays > 0 && this.accountingSummary.maxDeltaDays < 15) {
          return {
            borderClass: 'border-status-warning',
            status: 'Ubetalt <15d',
            iconClass: ['budicon-wall-clock'],
            class: base.concat(['bg-op-warning']),
            amountDue: this.accountingSummary.amountDue,
          };
        }

        if (this.accountingSummary.maxDeltaDays > 15) {
          return {
            borderClass: 'border-status-danger',
            status: 'Ubetalt >15d',
            iconClass: ['budicon-wall-clock'],
            class: base.concat(['bg-op-danger']),
            amountDue: this.accountingSummary.amountDue,
          };
        }

        if (this.accountingSummary.maxDeltaDays === 0 && this.accountingSummary.amountDue === 0) {
          return {
            borderClass: 'border-status-primary',
            status: 'Alt ok',
            iconClass: ['budicon-tick-sign'],
            class: base.concat(['bg-op-primary']),
            amountDue: 0,
          };
        }
      }

      return {
        borderClass: 'border-status-secondary',
        status: 'Ukjent status',
        iconClass: ['budicon-wall-clock'],
        class: base.concat(['bg-op-secondary']),
        amountDue: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.border-payment-status {
  border-left-width: 8px;
  border-left-style: solid;
}

.border-status {
  border-left-width: 5px;
  border-left-style: solid;
}

.border-status-danger {
  border-left-color: $danger;
}

.border-status-secondary {
  border-left-color: $secondary;
}

.border-status-warning {
  border-left-color: $warning;
}

.border-status-primary {
  border-left-color: $primary;
}

.icon-container {
  border-radius: 50%;
  padding: 1rem;
  text-align: center;
  font-size: 1.4rem;
  width: 60px;
  height: 60px;
}

.bg-op-primary {
  background: rgba($primary, 0.2);
}

.bg-op-secondary {
  background: rgba($info, 0.2);
}

.bg-op-success {
  background: rgba($success, 0.2);
}

.bg-op-warning {
  background: rgba($warning, 0.2);
}

.bg-op-danger {
  background: rgba($danger, 0.2);
}
</style>
